import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../lib/auth";

export default function DriverSetPassword() {
  const { user, ready, setDriverPassword } = useAuth();
  const nav = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (ready && !user) return <Navigate to="/driver/login" replace />;
  if (ready && user?.role !== "driver") return <Navigate to="/admin" replace />;
  if (ready && user?.role === "driver" && !user?.requires_password_change) return <Navigate to="/driver" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const result = await setDriverPassword(newPassword, confirmPassword);
    setBusy(false);
    if (!result.ok) {
      toast.error(result.error);
      return;
    }
    toast.success("Password updated successfully.");
    nav("/driver", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-5">
      <form onSubmit={submit} data-testid="driver-set-password-form" className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-8 space-y-5">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-sky-700">Driver security</p>
          <h1 className="font-heading text-2xl font-semibold tracking-tight mt-1">Set a new password</h1>
          <p className="mt-2 text-sm text-slate-600">For security, you need to set a new password before continuing.</p>
        </div>
        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-700">New password</span>
          <input data-testid="driver-set-password-new" type="password" required value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="mt-1.5 h-10 w-full rounded-md border border-slate-300 px-3 text-sm outline-none focus:border-slate-900 focus:ring-1 focus:ring-slate-900" />
        </label>
        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-700">Confirm password</span>
          <input data-testid="driver-set-password-confirm" type="password" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="mt-1.5 h-10 w-full rounded-md border border-slate-300 px-3 text-sm outline-none focus:border-slate-900 focus:ring-1 focus:ring-slate-900" />
        </label>
        <button type="submit" disabled={busy} data-testid="driver-set-password-submit" className="w-full rounded-md bg-slate-900 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60">
          {busy ? "Updating…" : "Update password"}
        </button>
      </form>
    </div>
  );
}